import React, { createContext, useContext, useEffect, useMemo, } from 'react';
import { useAppDispatch } from '@/store/hooks';
import { Localization } from '@/localization';
import { addError } from '@/store/slices/notificationsSlice';
import { usePreferredLanguage } from '@/store/selectors';
import { useGetTenantSettingsQuery } from '@/store/api';
import { FeatureFlag, useFeatureFlagsProvider } from '@/search-for-retail/feature-flags';
import { SimpleLoading } from '@/components/loading.component';
import { logError } from '@/utils/logger';
const LocaleContext = createContext({
    locale: Localization.DEFAULT_LANGUAGE_CODE,
});
export const LocaleProvider = ({ children }) => {
    const dispatch = useAppDispatch();
    const { featureFlagsService } = useFeatureFlagsProvider();
    const isEmojiLangEnabled = featureFlagsService.isFeatureEnabled(FeatureFlag.EmojiLang);
    const userPreferredLanguage = usePreferredLanguage();
    // Always fetch tenant settings (needed for auth0Region and other config)
    const { data: tenantSettings, isLoading, isError } = useGetTenantSettingsQuery();
    useEffect(() => {
        if (isError) {
            const errorMessage = 'TASK_GET_TENANT_SETTINGS_ERROR';
            logError(errorMessage);
            dispatch(addError({ key: errorMessage }));
        }
    }, [isError, dispatch]);
    const preferredLocale = useMemo(() => {
        var _a;
        return (isEmojiLangEnabled
            ? Localization.QALanguage.EMOJI
            : (_a = userPreferredLanguage !== null && userPreferredLanguage !== void 0 ? userPreferredLanguage : tenantSettings === null || tenantSettings === void 0 ? void 0 : tenantSettings.preferredLanguage) !== null && _a !== void 0 ? _a : Localization.DEFAULT_LANGUAGE_CODE);
    }, [userPreferredLanguage, tenantSettings === null || tenantSettings === void 0 ? void 0 : tenantSettings.preferredLanguage, isEmojiLangEnabled]);
    if (isLoading) {
        return <SimpleLoading />;
    }
    return (<LocaleContext.Provider value={{ locale: preferredLocale }}>
      {children}
    </LocaleContext.Provider>);
};
export const useLocale = () => useContext(LocaleContext);
